"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTS004_List = void 0;
const react_1 = __importDefault(require("react"));
const RegistButton_1 = require("../RegistButton");
const QnAListTable_1 = require("./DTST004_List_Child/QnAListTable");
exports.DSTS004_List = react_1.default.memo(({ isTeacher }) => {
    const handlerButtonClick = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'regist',
            id: undefined,
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(QnAListTable_1.QnAListTable, { isTeacher: isTeacher }),
        !isTeacher && react_1.default.createElement(RegistButton_1.RegistButton, { handlerButtonClick: handlerButtonClick })));
});
